export default __webpack_public_path__ + "static/media/services_illustration.ca386172.svg";